var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable no-redeclare */
import { useState, useCallback } from 'react';
export function useControlled(props, options) {
    if (props === void 0) { props = {}; }
    if (options === void 0) { options = {}; }
    var _defaultValue = options.defaultValue, _a = options.defaultValuePropName, defaultValuePropName = _a === void 0 ? 'defaultValue' : _a, _b = options.valuePropName, valuePropName = _b === void 0 ? 'value' : _b, _c = options.onChangePropName, onChangePropName = _c === void 0 ? 'onChange' : _c;
    var propValue = props[valuePropName];
    var propOnChange = props[onChangePropName];
    var defaultValue = defaultValuePropName in props ? props[defaultValuePropName] : _defaultValue;
    var isControlled = valuePropName in props;
    var _d = __read(useState(function () { return (isControlled ? propValue : defaultValue); }), 2), innerState = _d[0], setInnerState = _d[1];
    var state = (isControlled ? propValue : innerState);
    var setState = useCallback(function (state) {
        var otherParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            otherParams[_i - 1] = arguments[_i];
        }
        setInnerState(state);
        if (propOnChange) {
            propOnChange.apply(void 0, __spreadArray([state], __read(otherParams), false));
        }
    }, [propOnChange]);
    return [state, setState];
}
